export const youTubeAlreadyAllowListed = "yt_site_already_allowlisted";
export const youTubeAutoAllowlisted = "yt_auto_allowlisted";
export const youTubeWallDetected = "yt_site_ad_wall_detected";
export const youTubeNavigation = "yt_site_navigation";
export const adShownEvent = "yt_site_ad_shown";
export const toastShownEvent = "yt_site_toast_shown";
export const contextTamperingEvent = "yt_site_context_tampering";
export const errorEvent = "yt_site_yt_error";
export var AllowlistScope;
(function (AllowlistScope) {
    AllowlistScope["TAB"] = "tab";
    AllowlistScope["VIDEO"] = "video";
})(AllowlistScope || (AllowlistScope = {}));
export var ErrorType;
(function (ErrorType) {
    ErrorType["PLAYER_ERROR"] = "player_error";
    ErrorType["UNCAUGHT_EXCEPTION"] = "uncaught_exception";
    ErrorType["SWW_ERROR"] = "sww_error";
})(ErrorType || (ErrorType = {}));
export const ytRecordEvent = "yt-site.record-event";
